const endpoints = {
  candidateList: '/v1/recruitment/candidates',
  candidateDetail: '/v1/recruitment/candidates/:id',
  candidateTimeline: '/v1/recruitment/candidates/:id/timeline',
  candidateDocumentLinks: '/v1/recruitment/candidates/:id/document-links',
  locationsByRegion: '/v1/recruitment/regions',
  recruitStages: '/v1/recruitment/stages',
  triggerStageLink: '/v1/recruitment/candidates/:id/retrigger-step',
};

export default endpoints;
